var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema/fetcher";
const getRemoteFilesPlugins = fetcher.path("/api/remote_files/plugins").method("get").create();
/**
 * Get the list of available file sources from the server that can be browsed.
 * @param options The options to filter the file sources.
 * @returns The list of available (browsable) file sources from the server.
 */
export function getFileSources(options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getRemoteFilesPlugins({
            browsable_only: true,
            include_kind: options.include,
            exclude_kind: options.exclude,
        });
        return data;
    });
}
export const remoteFilesFetcher = fetcher.path("/api/remote_files").method("get").create();
/**
 * Get the list of files and directories from the server for the given file source URI.
 * @param uri The file source URI to browse.
 * @param isRecursive Whether to recursively retrieve all files inside subdirectories.
 * @param writeable Whether to return only entries that can be written to.
 * @returns The list of files and directories from the server for the given URI.
 */
export function browseRemoteFiles(uri, isRecursive = false, writeable = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield remoteFilesFetcher({ target: uri, recursive: isRecursive, writeable });
        return data;
    });
}
const createEntry = fetcher.path("/api/remote_files").method("post").create();
/**
 * Create a new entry (directory/record) on the given file source URI.
 * @param uri The file source URI to create the entry in.
 * @param name The name of the entry to create.
 * @returns The created entry details.
 */
export function createRemoteEntry(uri, name) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield createEntry({ target: uri, name: name });
        return data;
    });
}
